import React from 'react';
import { Link } from 'react-router-dom';
import './CompanyOverView.css';

const CompanyOverView = () => {
    return (
        <>
            {/* ==================== SECTION 1: DMT EMPIRE ==================== */}
            <section id="dmtkendra" className="why-us-modern-v2 section-bg dmt py-3">
                <div className="container" data-aos="fade-up">
                    <div className="row align-items-center gy-5">

                        <div className="col-lg-7 d-flex flex-column justify-content-center order-2 order-lg-1">
                            <div className="content-header-v2 mb-4">
                                <div className="badge-wrapper-v2">
                                    <span className="subtitle-tag-v2">Pioneering Since 2015</span>
                                </div>
                                <h3 className="company-title-v2 mt-3 mb-3">
                                    DMT EMPIRE INDIA <span className="title-highlight-v2">PRIVATE LIMITED</span>
                                </h3>
                                <div className="divider-line-v2 mb-3"></div>
                                <p className="text-muted modern-lead-v2 text-justify">
                                    DMT has been a pioneering force at the intersection of travel, financial inclusion, utility payments, and financial services. Our comprehensive range of offerings caters to diverse needs, providing seamless solutions to enhance convenience and accessibility for our B2B partners and customers.
                                </p>
                            </div>

                            <div className="modern-services-list-v2 mb-4">
                                <ul className="list-unstyled d-flex flex-column gap-3">
                                    <li>
                                        <Link to="/travel" className="service-card-link-v2">
                                            <div className="icon-wrapper-v2 bg-gradient-travel">
                                                <i className="icofont-airplane-alt"></i>
                                            </div>
                                            <div className="service-text-v2">
                                                <h5>Travel Services</h5>
                                                <p>Seamless ticket booking and premium travel arrangements.</p>
                                            </div>
                                            <div className="arrow-box-v2">
                                                <i className="bx bx-chevron-right arrow-icon-v2"></i>
                                            </div>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/banking" className="service-card-link-v2">
                                            <div className="icon-wrapper-v2 bg-gradient-banking">
                                                <i className="icofont-bank-alt"></i>
                                            </div>
                                            <div className="service-text-v2">
                                                <h5>Digital Banking</h5>
                                                <p>Promoting financial inclusion through accessible banking ecosystem.</p>
                                            </div>
                                            <div className="arrow-box-v2">
                                                <i className="bx bx-chevron-right arrow-icon-v2"></i>
                                            </div>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/utility" className="service-card-link-v2">
                                            <div className="icon-wrapper-v2 bg-gradient-utility">
                                                <i className="icofont-file-document"></i>
                                            </div>
                                            <div className="service-text-v2">
                                                <h5>Utility Payment Services</h5>
                                                <p>Streamlined, secure, and instant utility bill collections.</p>
                                            </div>
                                            <div className="arrow-box-v2">
                                                <i className="bx bx-chevron-right arrow-icon-v2"></i>
                                            </div>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/cashdrop" className="service-card-link-v2">
                                            <div className="icon-wrapper-v2 bg-gradient-cash">
                                                <i className="icofont-money"></i>
                                            </div>
                                            <div className="service-text-v2">
                                                <h5>Cash Management System</h5>
                                                <p>Secure, enterprise-grade and efficient cash drop handling.</p>
                                            </div>
                                            <div className="arrow-box-v2">
                                                <i className="bx bx-chevron-right arrow-icon-v2"></i>
                                            </div>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/insurance" className="service-card-link-v2">
                                            <div className="icon-wrapper-v2 bg-gradient-insurance">
                                                <i className="icofont-shield-alt"></i>
                                            </div>
                                            <div className="service-text-v2">
                                                <h5>Composite Insurance</h5>
                                                <p>Comprehensive insurance suites designed for complete security.</p>
                                            </div>
                                            <div className="arrow-box-v2">
                                                <i className="bx bx-chevron-right arrow-icon-v2"></i>
                                            </div>
                                        </Link>
                                    </li>
                                </ul>
                            </div>

                            <div className="cta-wrapper-v2">
                                <Link to="https://www.dialmytrip.com/" className="btn-modern-primary-v2" target="_blank" rel="noopener noreferrer">
                                    <span>Discover Ecosystem</span> <i className="icofont-arrow-right ms-2"></i>
                                </Link>
                            </div>
                        </div>

                        <div className="col-lg-5 order-1 order-lg-2 text-center" data-aos="zoom-in" data-aos-delay="150">
                            <div className="image-container-modern-v2">
                                <div className="glow-backdrop-v2 glow-blue"></div>
                                <img
                                    src={require("../../static/img/dialMyTrip.png")}
                                    alt="Dial My Trip"
                                    className="img-fluid floating-animation-v2"
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* ==================== SECTION 2: SHARDAJEET FOUNDATION ==================== */}
            <section id="Shardajeet" className="skills sharda-modern-v2 py-3">
                <div className="container" data-aos="fade-up">
                    <div className="row align-items-center gy-5">

                        <div className="col-lg-6 d-flex justify-content-center order-2 order-lg-1" data-aos="fade-right" data-aos-delay="100">
                            <div className="ngo-image-wrapper-v2">
                                <div className="glow-backdrop-v2 glow-green"></div>
                                <img
                                    src={require("../../static/img/tree.png")}
                                    className="img-fluid floating-graphic-v2"
                                    alt="Shardajeet Pillars"
                                 />
                            </div>
                        </div>

                        <div className="col-lg-6 content order-1 order-lg-2" data-aos="fade-left" data-aos-delay="100">
                            <div className="content-header-v2 mb-4">
                                <div className="badge-wrapper-v2">
                                    <span className="ngo-badge-v2"><i className="icofont-users-social me-1"></i> Empowerment Scheme</span>
                                </div>
                                <h3 className="ngo-title-v2 mt-3 mb-3">Shardajeet Foundation</h3>
                                <div className="divider-line-v2 divider-green mb-3"></div>
                                <p className="ngo-description-v2 text-justify">
                                    A dedicated Social Service Organization working tirelessly for the welfare and empowerment of underprivileged communities. The mission of this foundation is to provide necessary resources like books and scholarships to students, while actively streamlining eyesight care within our key health segment.
                                </p>
                            </div>

                            <div className="ngo-pillars-grid-v2 d-flex flex-column gap-3">
                                <div className="pillar-card-v2 p-border-health">
                                    <div className="pillar-icon-box-v2 p-bg-health">
                                        <i className="icofont-heart-beat"></i>
                                    </div>
                                    <div className="pillar-info-v2">
                                        <h5>Health & Eyesight Care</h5>
                                        <p>Mainly focused on treating the eyesight segment and organizing free specialized medical camps.</p>
                                    </div>
                                </div>

                                <div className="pillar-card-v2 p-border-education">
                                    <div className="pillar-icon-box-v2 p-bg-education">
                                        <i className="icofont-education"></i>
                                    </div>
                                    <div className="pillar-info-v2">
                                        <h5>Education Support</h5>
                                        <p>Providing books, learning digital platforms, and financial scholarships to deserving pupils.</p>
                                    </div>
                                </div>

                                <div className="pillar-card-v2 p-border-environment">
                                    <div className="pillar-icon-box-v2 p-bg-environment">
                                        <i className="icofont-tree"></i>
                                    </div>
                                    <div className="pillar-info-v2">
                                        <h5>Environment Preservation</h5>
                                        <p>Driving continuous sustainable green initiatives, urban forestry, and eco-plantation drives.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="cta-action-v2 mt-4">
                                <Link to="https://shardajeetfoundation.org/" className="btn-ngo-primary-v2" target="_blank" rel="noopener noreferrer">
                                    <span>Support Our Cause</span> <i className="icofont-heart ms-2"></i>
                                </Link>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* ==================== SECTION 3: FINWELCO ==================== */}
            <section id="Finwelco" className="finwelco-modern-v2 py-3">
                <div className="container" data-aos="fade-up">
                    <div className="row align-items-center gy-5">

                        <div className="col-lg-7 order-2 order-lg-1">
                            <div className="finwelco-header-v2 mb-4">
                                <div className="badge-wrapper-v2">
                                    <span className="fin-badge-v2"><i className="icofont-badge me-1"></i> Wealth & Protection Solutions</span>
                                </div>
                                <h3 className="fin-title-v2 mt-3 mb-3">Finwelco</h3>
                                <div className="divider-line-v2 divider-indigo mb-3"></div>
                                <p className="text-muted fin-lead-v2 text-justify">
                                    Finwelco is a premier corporate entity in the financial ecosystem, delivering a tailored spectrum of advisory products. Specializing in strategic insurance, long-term mutual fund architectures, and customized credit or loan options, we emphasize transparency to anchor asset development for global businesses and retail portfolios alike.
                                </p>
                            </div>

                            <div className="fin-product-grid-v2 mb-4">
                                <div className="row gy-3">

                                    <div className="col-sm-6">
                                        <div className="fin-item-card-v2">
                                            <div className="fin-icon-v2 bg-indigo-light">
                                                <i className="icofont-umbrella-alt"></i>
                                            </div>
                                            <div className="fin-details-v2">
                                                <h6>Life Insurance</h6>
                                                <p>Guaranteed institutional security setups for your loved ones.</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-sm-6">
                                        <div className="fin-item-card-v2">
                                            <div className="fin-icon-v2 bg-coral-light">
                                                <i className="icofont-car-alt-1"></i>
                                            </div>
                                            <div className="fin-details-v2">
                                                <h6>Motor Insurance</h6>
                                                <p>Comprehensive automated asset coverage and smart claims.</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-sm-6">
                                        <div className="fin-item-card-v2">
                                            <div className="fin-icon-v2 bg-purple-light-v2">
                                                <i className="icofont-chart-growth"></i>
                                            </div>
                                            <div className="fin-details-v2">
                                                <h6>Mutual Funds</h6>
                                                <p>Systematic multi-cap equity wealth maximization engines.</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-sm-6">
                                        <div className="fin-item-card-v2">
                                            <div className="fin-icon-v2 bg-emerald-light">
                                                <i className="icofont-bank"></i>
                                            </div>
                                            <div className="fin-details-v2">
                                                <h6>Home Loans</h6>
                                                <p>High-value commercial and residential micro-lending schemes.</p>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div className="fin-cta-box-v2">
                                <Link to="https://finwelco.com/" className="btn-fin-primary-v2" target="_blank" rel="noopener noreferrer">
                                    <span>Launch Premium Portfolio</span> <i className="icofont-ui-browser ms-2"></i>
                                </Link>
                            </div>
                        </div>

                        <div className="col-lg-5 order-1 order-lg-2 text-center" data-aos="zoom-in" data-aos-delay="150">
                            <div className="fin-img-container-v2">
                                <div className="glow-backdrop-v2 glow-indigo"></div>
                                <img
                                    src={require("../../static/img/finwelco.png")}
                                    alt="Finwelco Financial Intelligence"
                                    className="img-fluid fin-hero-img-v2"
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </section>

             {/* ==================== SECTION 4: COUPONFARES (TRAVEL ECOSYSTEM) ==================== */}

              <section id="Shardajeet" className="skills sharda-modern-v2 py-3">
                <div className="container" data-aos="fade-up">
                    <div className="row align-items-center gy-5">

                        <div className="col-lg-6 d-flex justify-content-center order-2 order-lg-1" data-aos="fade-right" data-aos-delay="100">
                            <div className="ngo-image-wrapper-v2">
                                <div className="glow-backdrop-v2 glow-green"></div>
                                <img
                                    src={require("../../static/img/flight.png")}
                                    className="img-fluid floating-graphic-v2"
                                    alt="Shardajeet Pillars"
                                 />
                            </div>
                        </div>

                        <div className="col-lg-6 content order-1 order-lg-2" data-aos="fade-left" data-aos-delay="100">
                            <div className="content-header-v2 mb-4">
                                <div className="badge-wrapper-v2">
                                    <span className="ngo-badge-v2">
                                    <i className="icofont-badge me-1"></i> 
                                    Smart Travel & Mobility Solutions 
                                    </span>
                                </div>
                                <h3 className="ngo-title-v2 mt-3 mb-3">CouponFares</h3>
                                <div className="divider-line-v2 divider-green mb-3"></div>
                                <p className="ngo-description-v2 text-justify">
                                    CouponFares is a premier B2B and retail travel aggregation platform, delivering a seamless spectrum of mobility services. Specializing in instant flight booking architectures, real-time train reservation interfaces, and network-wide bus ticketing, we emphasize cost-optimization and transparency to deliver unbeatable fares for agents and global travelers alike.
                                </p>
                            </div>

                            <div className="ngo-pillars-grid-v2 d-flex flex-column gap-3">
                                <div className="pillar-card-v2 p-border-health">
                                    <div className="pillar-icon-box-v2 p-bg-health">
                                        <i className="icofont-airplane-alt"></i>
                                    </div>
                                    <div className="pillar-info-v2">
                                        <h5>Flight Booking</h5>
                                        <p>Instant ticketing setups with premium low-fare calendar matrices.</p>
                                    </div>
                                </div>

                                <div className="pillar-card-v2 p-border-education">
                                    <div className="pillar-icon-box-v2 p-bg-education">
                                        <i className="icofont-train-line"></i>
                                    </div>
                                    <div className="pillar-info-v2">
                                        <h5>Train Booking</h5>
                                        <p>Comprehensive automated route coverage with quick PNR confirmation status.</p>
                                    </div>
                                </div>

                                <div className="pillar-card-v2 p-border-environment">
                                    <div className="pillar-icon-box-v2 p-bg-environment">
                                        <i className="icofont-bus"></i>
                                    </div>
                                    <div className="pillar-info-v2">
                                        <h5>Bus Booking</h5>
                                        <p>High-inventory commercial bus operators with real-time seat tracking layouts.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="cta-action-v2 mt-4">
                                <Link to="https://couponfares.com/" className="btn-ngo-primary-v2" target="_blank" rel="noopener noreferrer">
                                    <span>Explore CouponFares</span> <i className="icofont-heart ms-2"></i>
                                </Link>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
           
        </>
    );
};

export default CompanyOverView;